module.exports = __webpack_public_path__ + "static/media/users.9476b612.jpg";